/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react";
import { Row, Col, Menu, Dropdown, Button, message, Card } from "antd";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { ChartCard } from "../../../components/widget";
import Layout from "../../../layouts/MocoLayout";
import oRest from "../../../apis/rest";
import config from "./index.config";
import useWindowDimensions from "../../../helper/viewport";

const API_URL = "webhook/dataquery/?qname=";

const menuCardStyle = {
  padding: 12,
  borderRadius: 16,
  color: "#fff",
  backgroundColor: "#1B6FBA",
  margin: "0px 12px 12px 0px",
  textAlign: "center",
};

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [selectedAgama, setAgama] = useState("");
  const [selectedProvince, setProvince] = useState("");
  const [provinceMenu, setProvinceMenu] = useState([]);
  const agama = ["Khonghucu", "Hindu", "Buddha", "Kristen", "Katolik"];

  const { width } = useWindowDimensions();

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}survey5agama_list_provinsi`;
      oRest
        .get(api)
        .then(({ data }) => {
          setProvinceMenu(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.sumberKurikulum.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sumberKurikulum: {
                ...card.chart.sumberKurikulum,
                options: {
                  ...card.chart.sumberKurikulum.options,
                  chartOption: {
                    ...card.chart.sumberKurikulum.options.chartOption,
                    yAxis: {
                      ...card.chart.sumberKurikulum.options.chartOption.yAxis,
                      data: data.map((e) => e.sumber_kurikulum),
                    },
                    series: [
                      {
                        ...card.chart.sumberKurikulum.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.komposisiKurikulum.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => b.count - a.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              komposisiKurikulum: {
                ...card.chart.komposisiKurikulum,
                options: {
                  ...card.chart.komposisiKurikulum.options,
                  chartOption: {
                    ...card.chart.komposisiKurikulum.options.chartOption,
                    xAxis: {
                      ...card.chart.komposisiKurikulum.options.chartOption
                        .xAxis,
                      data: data.map((e) => e.kurikulum_komposisi),
                    },
                    series: [
                      {
                        ...card.chart.komposisiKurikulum.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.evaluasiAkademik.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              evaluasiAkademik: {
                ...card.chart.evaluasiAkademik,
                options: {
                  ...card.chart.evaluasiAkademik.options,
                  chartOption: {
                    ...card.chart.evaluasiAkademik.options.chartOption,
                    yAxis: {
                      ...card.chart.evaluasiAkademik.options.chartOption.yAxis,
                      data: data.map((e) => e.evaluasi_akademik),
                    },
                    series: [
                      {
                        ...card.chart.evaluasiAkademik.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.evalNonAkademik.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              evalNonAkademik: {
                ...card.chart.evalNonAkademik,
                options: {
                  ...card.chart.evalNonAkademik.options,
                  chartOption: {
                    ...card.chart.evalNonAkademik.options.chartOption,
                    yAxis: {
                      ...card.chart.evalNonAkademik.options.chartOption.yAxis,
                      data: data.map((e) => e.evaluasi_nonakademik),
                    },
                    series: [
                      {
                        ...card.chart.evalNonAkademik.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.mediaPembelajaran.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => b.count - a.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              mediaPembelajaran: {
                ...card.chart.mediaPembelajaran,
                options: {
                  ...card.chart.mediaPembelajaran.options,
                  chartOption: {
                    ...card.chart.mediaPembelajaran.options.chartOption,
                    xAxis: {
                      ...card.chart.mediaPembelajaran.options.chartOption.xAxis,
                      data: data.map((e) => e.evaluasi_mediapembelajaran),
                    },
                    series: [
                      {
                        ...card.chart.mediaPembelajaran.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  const handleFilterAgama = (value) => {
    setAgama(value.key === "all" ? "" : value.key);
  };

  const handleFilterProvinsi = (value) => {
    setProvince(value.key === "all" ? "" : value.key);
  };

  const agamaMenu = (
    <Menu onClick={handleFilterAgama}>
      <Menu.Item key="all">Semua Agama</Menu.Item>
      {agama.map((e) => {
        return <Menu.Item key={e}>{e}</Menu.Item>;
      })}
    </Menu>
  );

  const provinceDropdownMenu = (
    <Menu onClick={handleFilterProvinsi}>
      <Menu.Item key="all">Nasional</Menu.Item>
      {provinceMenu
        ?.map((e) => e.lembaga_provinsi)
        .sort((a, b) =>
          // eslint-disable-next-line no-nested-ternary
          a > b ? 1 : b > a ? -1 : 0
        )
        .map((e) => {
          return <Menu.Item key={e}>{toPascalCase(e)}</Menu.Item>;
        })}
    </Menu>
  );

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          flexFlow: "row",
          flexWrap: "wrap",
          justifyContent: width > 795 ? "space-between" : "center",
        }}
      >
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Link to="/pendidikan-keagamaan/1" key="overview">
              <Col style={menuCardStyle}>
                <span className="text-default">Overview</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/2" key="lembaga">
              <Col style={menuCardStyle}>
                <span className="text-default">Lembaga</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/3" key="sdm">
              <Col style={menuCardStyle}>
                <span className="text-default">SDM</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/4" key="sarana">
              <Col style={menuCardStyle}>
                <span className="text-default">Sarana</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/5" key="pendidikan">
              <Col style={menuCardStyle}>
                <span className="text-default">Pendidikan</span>
              </Col>
            </Link>
          </Row>
        </div>
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Col>
              <Dropdown overlay={agamaMenu}>
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih agama &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
            <Col>
              <Dropdown
                overlay={provinceDropdownMenu}
                overlayStyle={{ height: 300, overflowY: "auto" }}
              >
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih provinsi &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </div>
      </div>
      <Row gutter={[24, 24]} style={{ paddingTop: "8px" }}>
        <Col span={24}>
          <Card
            style={{
              borderRadius: 16,
            }}
          >
            <span
              style={{
                fontSize: 26,
                fontWeight: 500,
                color: "#1B6FBA",
              }}
            >
              {`Sebaran Data ${
                selectedAgama === "" ? "Semua Agama" : `Agama ${selectedAgama}`
              } di ${
                selectedProvince === ""
                  ? "Seluruh Provinsi"
                  : `Provinsi ${selectedProvince}`
              }`}
            </span>
          </Card>
        </Col>
        <Col span={12} className="text-header" style={{ padding: "0 8px" }}>
          Kurikulum
        </Col>
      </Row>
      <Row gutter={[24, 24]}>
        <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.sumberKurikulum} />
        </Col>
        <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.komposisiKurikulum} />
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ paddingTop: "8px" }}>
        <Col span={24} className="text-header" style={{ padding: "0 8px" }}>
          Sistem Evaluasi
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ paddingBottom: "15px" }}>
        <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.evaluasiAkademik} />
        </Col>
        <Col span={12} style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.evalNonAkademik} />
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ padding: "8px 0" }}>
        <Col span={24} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.mediaPembelajaran} />
        </Col>
      </Row>
    </Layout>
  );
};

export default Page;
